import React from "react"
import { LabelGroup } from "./display/LabelGroup"
import { SUBJECT_TYPES } from "../constants"
import { SRS_STAGES } from "../constants"
// const resources = ["Assignments", "Subjects"]

export const RequestForm = ({
  requestParams,
  setRequestParams,
  // resourceType,
  // setResourceType,
}) => {
  const srsArray = Object.values(SRS_STAGES).map(srs => {
    return {...srs, key: srs.label.toUpperCase()}
  })

  return (
    <section className="request-params-form">
      <h2>Fetch</h2>

      {/* Uncomment to restore subjects fetch
        <select
        onChange={(e) => setResourceType(e.target.value)}
        value={resourceType}
      >
        {resources.map((resource) => (
          <option key={resource} value={resource.toLowerCase()}>
            {resource}
          </option>
        ))}
      </select> */}

      <div className="levels-container">
        <LabelGroup labelValue="Fetch by level:" forId="level-input">
          <input
            id="level-input"
            type="number"
            onChange={(e) =>
              setRequestParams({ ...requestParams, levels: e.target.value })
            }
            value={requestParams.levels}
          />
        </LabelGroup>
        <LabelGroup labelValue="Fetch by SRS stage:" forId="srs-input">
          <select
            id="stages-input"
            onChange={(e) => {
              setRequestParams({
                ...requestParams,
                srs_key: e.target.value,
              })
            }}
            value={requestParams.srs_key}
          >
            {srsArray.map((srsLvl) => (
              <option key={srsLvl.label} value={srsLvl.key}>
                {srsLvl.label}
              </option>
            ))}
          </select>
        </LabelGroup>
        <LabelGroup labelValue="Subject Type" forId="types-input">
          <select
            id="types-input"
            onChange={(e) =>
              setRequestParams({
                ...requestParams,
                types: e.target.value,
                subject_types: e.target.value,
              })
            }
            value={requestParams.types}
          >
            {SUBJECT_TYPES.map((subject) => (
              <option key={subject} value={subject.toLowerCase()}>
                {subject}
              </option>
            ))}
          </select>
        </LabelGroup>
      </div>
    </section>
  )
}
